const defaultState = () => ({
    courseAndLessonMenu: null,
    menuWithChildren: [],
    baseUrl: '',
    removedLessonId: null
});
export default defaultState;
